import React, {useEffect, useState} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';

const RequestInternal = ({
                         walletListing,
                         listing = []
                     }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [listData, setListData] = useState();
    const [roleId, setRoleId] = useState();

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            setRoleId(window.localStorage.getItem('fusion-role'));
            await walletListing(1)
            setIsLoading(false)
        })()
    }, [])

    const headers = [
        'Wallet Type',
        'Category',
        'Subcategory',
        'Amount',
        'Approved amount pending for addition',
        'Action'
    ];

    const headersByRoles = [
        'Wallet Type',
        'Category',
        'Subcategory',
        'Wallet Balance',
        'Hold Amount',
        'Final Amount',
        'Approved amount pending for addition',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await walletListing(val.selected + 1);
        setIsLoading(false);
    };

    useEffect(() => {
        if (listing && listing?.data !== undefined &&
            listing?.data?.resultSets !== undefined && listing?.data?.resultSets.length > 0) {
            let tableData = [];
             tableData = ['wallet_type', 'category_name', 'subcategory', 'balance', 'left_amount'];
            if(parseInt(roleId) === 47 || parseInt(roleId) === 26 || parseInt(roleId) === 13 || parseInt(roleId) === 49){
                tableData = ['wallet_type', 'category_name', 'subcategory', 'balance', 'hold_balance', 'final_balance' ,'left_amount'];
            }
            const data = listing?.data?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        {[key]: element[key]}
                    )),
                    {Action :
                            parseInt(JSON.parse(window.localStorage.roles)[0]?.id) !== 49 ?
                                [
                                    {name:'Request List', link:`wallet/approval/${element['category']}/${element['subcategory']}`},
                                ]
                            :
                                [
                                    {name:'Request List', link:`all-wallet-request-list/${element['category']}`},
                                ]
                    }
                )
            )
            if (data) {
                // const newCardData = data.map(function (obj) {
                //     obj['id'] = ''
                //     return obj;
                // });
                data && setListData(data);
            }
            setPageCount(Math.ceil(listing?.data.total / listing?.data.per_page));
        }
    }, [listing])

    return (
        <>
            <Layout
                title={localization.wallet}
                isLoading={isLoading}
                isGoback={true}
            >
                <TableSection
                    data={listData}
                    // isId={tr}
                    // isMngId={false}
                    headers={(parseInt(roleId) === 47 || parseInt(roleId) === 26 || parseInt(roleId) === 13 || parseInt(roleId) === 49) ? headersByRoles : headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={listing?.data && listing?.data?.resultSets}
                    srNo={listing?.from}
                />
            </Layout>
        </>
    )
}

export default RequestInternal

